import React, { useEffect, useState } from "react";
import Counter from "./Counter";

const HomeOneCounter = () => {
  const counters = [
    {
      id: 1,
      img: "https://caretutor-space-file.nyc3.cdn.digitaloceanspaces.com/assets/img/landing_page/total_apply.png",
      targetCount: 369500,
      label: "Active Tutors",
    },
    {
      id: 2,
      img: "https://caretutor-space-file.nyc3.cdn.digitaloceanspaces.com/assets/img/landing_page/total_jobs.png",
      targetCount: 284700,
      label: "Live Tuition Jobs",
    },
    {
      id: 3,
      img: "https://caretutor-space-file.nyc3.cdn.digitaloceanspaces.com/assets/img/landing_page/total_happy.png",
      targetCount: 100000,
      label: "Happy Students",
    },
    {
      id: 4,
      img: "https://caretutor-space-file.nyc3.cdn.digitaloceanspaces.com/assets/img/landing_page/total_rating.png",
      targetCount: 50000,
      label: "Average Tutor Rating",
    },
  ];

  return (
    <div className="bg-green-100">
      <div className="bg-green-100 border-b border-b-green-400">
        {/* <div className="lg:w-[70%]   py-2 flex  items-center flex-row justify-between md:w-[90%]   rounded-lg sm:w-[95%] mx-auto ">
          <div className="flex justify-center items-center">
            <div className="flex flex-row justify-center items-center">
              <svg
                id="Layer_1"
                enable-background="new 0 0 36 36"
                height="100"
                viewBox="0 0 36 36"
                width="100"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="_x39_2">
                  <g>
                    <g>
                      <path
                        d="m23.9 23.3v9.7c0 .8-.9 1.2-1.5.7l-3.4-2.8s-.1 0-.1-.1c-.3-.2-.6-.3-.9-.3-.4 0-.7.1-1 .4l-3.4 2.9c-.6.5-1.5.1-1.5-.7v-9.7h11.8z"
                        fill="#f45170"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="m23.9 23.3v9.7c0 .8-.9 1.2-1.5.7l-3.4-2.8s-.1 0-.1-.1c-.3-.2-.6-.3-.9-.3v-7.2z"
                        fill="#e93565"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="m23.9 25.6v1.5c-.9.2-2-.1-2.8.1-1 .3-2 1.4-3.1 1.4s-2.1-1.1-3.1-1.4c-.9-.2-2 .1-2.8-.1v-1.5z"
                        fill="#cc104a"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <path
                          d="m29.5 18c-.3 1.1.2 2.4-.3 3.4-.6 1-2 1.2-2.8 2s-1 2.2-2 2.8c-.9.5-2.3 0-3.4.3-1 .3-2 1.4-3.1 1.4s-2.1-1.1-3.1-1.4c-1.1-.3-2.4.2-3.4-.3-.9-.5-1.2-2-2-2.8s-2.2-1-2.8-2c-.5-.9 0-2.3-.3-3.4-.3-1-1.4-2-1.4-3.1s1.1-2.1 1.4-3.1c.3-1.1-.2-2.4.3-3.4.5-.9 2-1.2 2.8-2s1-2.2 2-2.8c.9-.5 2.3 0 3.4-.3 1-.3 2-1.4 3.1-1.4s2.1 1.1 3.1 1.4c1.1.3 2.4-.2 3.4.3.9.5 1.2 2 2 2.8s2.2 1 2.8 2c.5.9 0 2.3.3 3.4.3 1 1.4 2 1.4 3.1s-1.1 2.1-1.4 3.1z"
                          fill="#f9be48"
                        />
                      </g>
                    </g>
                    <g opacity=".4">
                      <g>
                        <path
                          d="m27.7 14.9c0 5.3-4.3 9.7-9.7 9.7-5.3 0-9.7-4.3-9.7-9.7 0-5.3 4.3-9.7 9.7-9.7 5.3 0 9.7 4.4 9.7 9.7z"
                          fill="#fff"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <g>
                          <g>
                            <g>
                              <g>
                                <path
                                  d="m26.7 14.9c0 4.8-3.9 8.7-8.7 8.7s-8.7-3.9-8.7-8.7 3.9-8.7 8.7-8.7 8.7 3.9 8.7 8.7z"
                                  fill="#f3a250"
                                />
                              </g>
                            </g>
                            <g>
                              <g>
                                <path
                                  d="m26.7 15.5c-.3-4.6-4.1-8.2-8.7-8.2s-8.4 3.6-8.7 8.2c-.3-5.2 3.9-9.4 8.7-9.3 4.9.1 9 4 8.7 9.3z"
                                  fill="#ef7b56"
                                />
                              </g>
                            </g>
                            <g>
                              <g>
                                <g>
                                  <path
                                    d="m20.8 16.2.5 3.1c.1.5-.4.8-.8.6l-2.7-1.4c-.2-.1-.4-.1-.5 0l-2.7 1.4c-.4.2-.9-.1-.8-.6l.5-3.1c0-.2 0-.4-.2-.5l-2.2-2.2c-.3-.3-.2-.9.3-1l3.1-.5c.2 0 .3-.1.4-.3l1.3-2.6c.2-.4.8-.4 1 0l1.4 2.8c.1.2.2.3.4.3l3.1.5c.5.1.7.6.3 1l-2.2 2c-.1.2-.2.3-.2.5z"
                                    fill="#ef7b56"
                                  />
                                </g>
                              </g>
                            </g>
                            <g>
                              <g>
                                <g>
                                  <path
                                    d="m21.3 16.7.5 3.1c.1.5-.4.8-.8.6l-2.7-1.4c-.2-.1-.4-.1-.5 0l-2.8 1.4c-.4.2-.9-.1-.8-.6l.5-3.1c0-.2 0-.4-.2-.5l-2.2-2.2c-.3-.3-.2-.9.3-1l3.1-.5c.2 0 .3-.1.4-.3l1.4-2.8c.2-.4.8-.4 1 0l1.4 2.8c.1.2.2.3.4.3l3.1.5c.5.1.7.6.3 1l-2.2 2.2c-.2.1-.2.3-.2.5z"
                                    fill="#f9cf6b"
                                  />
                                </g>
                              </g>
                            </g>
                          </g>
                          <g opacity=".5">
                            <g>
                              <path
                                d="m12.9 14.1c-.3-.3-.1-.8.3-.9l2.7-.4c.2 0 .3-.1.4-.3l1.2-2.5c.2-.4.7-.4.9 0l1.2 2.5c.1.2.2.3.4.3l2.7.4c.4.1.6.6.3.9 0 0-1.7 1.9-5.2 1.9-2.6 0-4.9-1.9-4.9-1.9z"
                                fill="#fff"
                              />
                            </g>
                          </g>
                        </g>
                        <g opacity=".7">
                          <g>
                            <path
                              d="m17.2 12.7c-.5-.2.3-2.3.8-2.1.3.1-.2 2.3-.8 2.1z"
                              fill="#fff"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path
                            d="m13.6 8.5c-.3 0-.5.2-.7.4.1.1 1.1.9 1 1s-1.1-.6-1.2-.7c-.1.2-.2.5-.1.7.3 2.5-.1 2.6-.6.1-.1-.3-.2-.5-.4-.7-.1.1-.9 1.1-1 1s.6-1.1.7-1.2c-.2-.1-.5-.1-.7-.1-2.6.2-2.7-.1-.1-.6.3-.1.5-.2.7-.4 0 0 0 0-.1-.1-1.4-1.1-1.2-1.2.2-.3h.1c.1-.2.2-.5.1-.7-.3-2.6.1-2.6.6-.1 0 .3.2.5.4.7 0 0 0 0 .1-.1 1.1-1.4 1.2-1.2.3.2v.1c.1.2.4.3.6.3 2.6-.3 2.6 0 .1.5z"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g opacity=".5">
                    <g>
                      <path
                        d="m13.6 30.1c0 1.4-.1 1.5-.3 1.5-.1 0-.3-.1-.3-1.5s.1-1.8.3-1.8.3.4.3 1.8z"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </g>
              </svg>

              <h1 className="text-start text-2xl font-bold text-green-900 font-montserrat">
                Learn with 100% satisfaction <br></br> guaranteed
              </h1>
            </div>
          </div>
          <div className="w-[55%]">
             <p className="text-xl  text-green-700 font-montserrat">
              If your lesson doesn't take place, or you are not satisfied with
              your tutor, we will do our best to ensure that your learning goals
              are achieved!
            </p> 
          </div> 
        </div> */}
      </div>
      <div className="bg-green-500 p-5 ">
        <div className="lg:w-[70%]  py-2 flex  items-center flex-row justify-between md:w-[90%]   rounded-lg sm:w-[95%] mx-auto ">
          <div className=" flex justify-between items-center w-full">
            {counters.map((counter) => (
              <div key={counter.id} className="text-center">
                <p className="text-white text-xl"></p>
                <div className="flex flex-row justify-center items-center gap-3">
                  <img src={counter.img} alt=""></img>
                  <div className="flex flex-col justify-start items-start gap-2">
                    <Counter targetCount={counter.targetCount} />

                    <h1 className="text-green-50  font-roboto text-lg">
                      {counter.label}
                    </h1>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeOneCounter;
